import React, { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { InjectedAccountWithMeta } from '@polkadot/extension-inject/types';

const Profile: React.FC = () => {
  const { accounts } = useAppContext();
  const navigate = useNavigate();
  const [isCopied, setIsCopied] = useState(false);

  if (!accounts.length) {
    navigate('/');
    return null;
  }

  const copyToClipboard = (account: InjectedAccountWithMeta) => {
    navigator.clipboard.writeText(account.address);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6">
      <h1 className="text-xl sm:text-2xl font-bold text-gray-800 dark:text-white mb-4 sm:mb-6">Profile</h1>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4 sm:p-6">
        <div className="space-y-4">
          <div>
            <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400">Wallet Address</h2>
            <div className="mt-1 flex flex-col sm:flex-row sm:items-center gap-2">
              <p className="text-sm sm:text-lg text-gray-900 dark:text-gray-200 break-all">{accounts[0].address}</p>
              <button
                onClick={() => copyToClipboard(accounts[0])}
                className={`px-3 py-2 sm:py-1 rounded-md text-sm transition-colors ${
                  isCopied 
                    ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300' 
                    : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                }`}
                title={isCopied ? "Copied!" : "Copy to clipboard"}
              >
                {isCopied ? '✓ Copied!' : '📋 Copy'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile; 